<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="sink-handler">
            <slot v-if="notFound">
                <h1>
                    {{ getVerbose('sink_handler_title') }}
                </h1>
                <p>{{ getVerbose('sink_handler_text') }}</p>
            </slot>
            <div v-else>
                <p>{{ getVerbose('sink_handler_loading') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    name: 'SinkHandler',
    data() {
        return {
            notFound: false,
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ])
    },
    mounted(){
        // This function will handle all routes not declared within router.
        // Redirect when already connected and doing login by email
        // to prevent NotFound
        if(window.location.href.includes('secure-connect')){
            if(this.$store.getters.userIsAuthenticated){
                this.$router.push('/');
            }
        }
        else{
            this.notFound = true;
        }
    },
};
</script>

<style lang="scss">
.sink-handler {
    padding-top: 15px;
    margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/sinkHandler.vue